import { Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ServiceListComponent implements OnInit, AfterViewInit {
  dataSource = new MatTableDataSource([]);
  displayedColumns = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  columnNames = [{
    id: 'sno',
    value: 'No.',

  },
  // {
  //   id: 'service_category',
  //   value: 'Service Category',
  // }, 
  {
    id: 'service_desc',
    value: 'Service Description',
  }, {
    id: 'price_s',
    value: 'Price (S)',
  }, {
    id: 'price_m',
    value: 'Price (m)',
  }, {
    id: 'price_l',
    value: 'Price (L)',
  },
  {
    id: 'actions',
    value: 'Action',
  }
  ];



  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any = {};
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  expandedElement: any | null;
  showUploadModal: boolean = false;
  selectedFile: File | null = null;
  uploadAccess: boolean;
  uploadErrors: any = [];
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('4');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }

    if (this.currentUser.dynamic_membership == '1') {
      this.columnNames = [
        { id: 'sno', value: 'No.' },
        { id: 'service_desc', value: 'Service Description' },
        { id: 'price_s', value: 'Price (S)' },
        { id: 'price_m', value: 'Price (m)' },
        { id: 'price_l', value: 'Price (L)' },
        { id: 'membership_price_s', value: 'Membership Price (S)' },
        { id: 'membership_price_m', value: 'Membership Price (m)' },
        { id: 'membership_price_l', value: 'Membership Price (L)' },
        { id: 'actions', value: 'Action' }
      ];
    }

    this.displayedColumns = this.columnNames.map(x => x.id);
    this.getserviceList('');
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.expandedElement = null; // Close any expanded row when filtering
  }

  addvendor() {
    this.router.navigate(['add-Servicelist']);
  }


  getserviceList(service_list_id) {
    this.loginservice.getserviceList(service_list_id, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
            this.dataSource.data = this.dataresult;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
          } else {
            this.dataresult.length = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            this.dataresult = [];
            this.dataSource.data = [];
          }
        },
        error => {
          alert('Network Error getserviceList API');
          this.showLoader = false;
        });
  }


  // Angular component code
  handleClick(columnId: string, element: any) {
    switch (columnId) {
      // case 'edit':
      //   this.edit(element.vendor_id);
      //   break;
      // case 'view':
      //   this.view(element.vendor_id);
      //   break;
      case 'delete':
        this.delete(element.vendor_id);
        break;
      default:
        break;
    }
  }

  delete(service_list_id: number) {
    if (confirm('Deleting of this Service List is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletegridData(service_list_id, 'id', 'service_list', 'status').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        },
          error => {
            alert('Error in delete');
            this.showLoader = false;
          });
      }
    }
  }



  toggleRow(row: any) {
    this.expandedElement = this.expandedElement === row ? null : row;
  }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      this.uploadAccess = !!mod.upload;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      this.uploadAccess = false;
      return false;
    }
  }


  openUploadModal() {
    this.showUploadModal = true;
  }

  closeUploadModal() {
    this.showUploadModal = false;
    this.uploadErrors = [];
    this.selectedFile = null;
  }

  // async downloadSample() {
  //   const XLSX = await import('xlsx');
  //   const wb = XLSX.utils.book_new();

  //   // Sheet 1: Customer Data Template
  //   const customerData = [
  //     ['Customer Name', 'Phone', 'How do You Know about this Place?'],
  //     ['', '', ''] // Empty row for data entry
  //   ];
  //   const ws1 = XLSX.utils.aoa_to_sheet(customerData);
  //   XLSX.utils.book_append_sheet(wb, ws1, 'customer_data');

  //   // Sheet 2: Reference Options
  //   const referenceOptions = [
  //     ['Reference Options For How do You Know about this Place?'],
  //     ['Banner'],
  //     ['Direct Walk In'],
  //     ['EGB Staff'],
  //     ['Facebook'],
  //     ['Google'],
  //     ['Instagram'],
  //     ['Missed To Ask'],
  //     ['Other'],
  //     ['Our Customer'],
  //     ['Our Staff'],
  //     ['Pamphlet'],
  //     ['Referred By Another Person']
  //   ];
  //   const ws2 = XLSX.utils.aoa_to_sheet(referenceOptions);
  //   XLSX.utils.book_append_sheet(wb, ws2, 'reference_options');

  //   XLSX.writeFile(wb, 'customer_template.xlsx');
  // }

  downloadSample() {
    const wb = XLSX.utils.book_new();
    let customerData: any[] = [];
    if (this.currentUser.dynamic_membership === '1') {
      customerData = [
        ['Service Name', 'Gender', 'Price (S)', 'Price (M)', 'Price (L)', 'Membership Price (S)', 'Membership Price (M)', 'Membership Price (L)'],
        ['', '', '0', '0', '0', '0', '0', '0']
      ];
    } else {
      customerData = [
        ['Service Name', 'Gender', 'Price (S)', 'Price (M)', 'Price (L)'],
        ['', '', '0', '0', '0']
      ];
    }
    const ws1 = XLSX.utils.aoa_to_sheet(customerData);
    XLSX.utils.book_append_sheet(wb, ws1, 'service_list_data');
    const referenceOptions = [
      ['Gender'],
      ['Both'],
      ['Female'],
      ['Male']
    ];
    const ws2 = XLSX.utils.aoa_to_sheet(referenceOptions);
    XLSX.utils.book_append_sheet(wb, ws2, 'reference_options');
    XLSX.writeFile(wb, 'service_list_template.xlsx');
  }


  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  uploadExcel() {
    if (!this.selectedFile) return;

    this.showLoader = true;
    const formData = new FormData();
    formData.append('file', this.selectedFile);

    this.loginservice.uploadServiceList(formData, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show(`Successfully uploaded ${data['count']} Service List`, { cssClass: 'alert-success' });
          this.closeUploadModal();
          this.ngOnInit();
        } else if (data['status'] === 'error') {
          this.uploadErrors = data['message'];
          // alert(data['message'] || 'Upload failed');
          // this._flashMessagesService.show(data['message'] || 'Upload failed', { cssClass: 'alert-danger' });
        } else {
          this._flashMessagesService.show('Upload failed', { cssClass: 'alert-danger' });
        }
        this.showLoader = false;
      },
      error => {
        this._flashMessagesService.show('Error uploading file', { cssClass: 'alert-danger' });
        this.showLoader = false;
      }
    );
  }

  exportToExcel() {
    const exportData = this.dataSource.filteredData.map((item, index) => {
      const data: any = {
        'No.': index + 1,
        'Service Description': item.service_desc,
        'Price (S)': item.price_s,
        'Price (M)': item.price_m,
        'Price (L)': item.price_l
      };

      if (this.currentUser.dynamic_membership == '1') {
        data['Membership Price (S)'] = item.membership_price_s;
        data['Membership Price (M)'] = item.membership_price_m;
        data['Membership Price (L)'] = item.membership_price_l;
      }

      return data;
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Service List');
    XLSX.writeFile(wb, `service_list_${new Date().getTime()}.xlsx`);
  }


}


// WEBPACK FOOTER //
// ./src/app/service-list/service-list.component.ts